export const FLAG_TYPE_SUCCESS = 'success';
export const FLAG_TYPE_ERROR = 'error';
export const FLAG_TYPE_INFO = 'info';
export const FLAG_TYPE_WARNING = 'warning';
export const TilesVariation = {
  LARGE: 'LARGE',
  SMALL: 'SMALL'
};
export const HighlightedSectionVariation = {
  PROMINENT: 'PROMINENT'
};
export const ProductMarketingGroupType = {
  COLLECTION: 'COLLECTION',
  CATEGORY: 'CATEGORY'
};
export const AppListingTab = {
  Overview: 'overview',
  Reviews: 'reviews',
  Pricing: 'pricing',
  Support: 'support',
  Versions: 'versions',
  Installation: 'installation',
  PrivacyAndSecurity: 'privacy-and-security'
};